import { StarFilled } from '@ant-design/icons'
import {StarOutlined} from '@ant-design/icons'
import styled from 'styled-components'
import { Button, Checkbox, Tag } from 'antd'
import { COLORS } from '../../../../../../../theme'

export const CourseBox = styled.div``

export const QualificationLevelSwitch = styled(Button)`
  margin: 1em;
  border: 1px solid gainsboro;
  border-radius: 10px;
  padding: 1em 1.5em;
  height: 3.5em;
  cursor: pointer;
  display: flex;
  align-items: center;
  letter-spacing: 0.1em;
  width: 9em;
  justify-content: center;
  background-color: ${props => (props.$selected || props.disabled ? '#3249D7' : '#fff')};
  color: ${props => (props.$selected || props.disabled ? '#fff' : 'black')};
  font-weight: ${props => (props.$selected || props.disabled ? 600 : 400)};
  /* No hover/focus effect */
  &:hover, &:focus {
    background-color: ${props => (props.$selected || props.disabled ? '#3249D7' : '#fff')};
    color: ${props => (props.$selected || props.disabled ? '#fff' : 'black')};
    border: 1px solid gainsboro;
    outline: none;
    box-shadow: none;
  }

`
export const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox + span {
    padding-left: 12px;
    font-size: 13px;
    font-weight: ${props => (props.fontWeight ? props.fontWeight : '400')};
  }
  .ant-checkbox-inner {
    width: 12px !important;
    height: 12px !important;
    border-radius: 3px !important;
  }

  .ant-checkbox-input {
    margin-bottom: 10px !important;
  }
  &.ant-checkbox-wrapper {
    align-items: flex-start !important;
  }
  .ant-checkbox {
    margin-top: 2px !important;
  }
`
export const SkillsWrapper = styled.div`
  /* margin-top: 24px; */
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`
export const MarginDiv = styled.div`
  margin-top: 10px;
`
export const Label1 = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #000;
  margin-bottom: 8px;
`

export const Note = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #4d568e;
  margin-bottom: 8px;
`

export const SkillList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`

export const SkillItem = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #e3deff;
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 14px;
  background-color: #fbfaff;
  color: #3249d7;
`

export const Icon = styled.span`
  margin-left: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
`
export const ScoreRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
`

export const ScoreBox = styled.input`
  flex: 1;
  min-width: 150px;
  padding: 10px 12px;
  font-size: 14px;
  border: none;

  background-color: ${({ disabled }) => (disabled ? '#f0f0f0' : '#fff')};
  color: ${({ disabled }) => (disabled ? '#999' : '#000')};

  &:focus {
    outline: none;
    border-color: #2a5bd7;
  }
`
export const StyledTag = styled(Tag)`
  border: 1px solid #E3DEFF !important;
  background-color: #FBFAFF !important;
  color: #3249D7 !important;
  font-weight: 500;
  border-radius: 12px !important;
  padding: 6px 12px !important;
  font-size: 16px !important;
  display: flex !important;
  align-items: center;
  .anticon-close {
    color: #3249D7;
    margin-left: 8px;
    &:hover {
      color: #3249D7;
    }
  }
`

export const StyledStarFilled = styled(StarFilled)`
  margin-left: 8px;
  color: #5b4eff;
  
`

export const StyledStarOutlined = styled(StarOutlined)`
  margin-left: 8px;
  color: #5b4eff;
  
`
export const TableCheckbox = styled(Checkbox)`
  .ant-checkbox + span {
    padding-left: 12px;
    font-size: 13px;
    font-weight: ${props => props.fontWeight || '400'};
    text-transform: capitalize;
  }
  margin-right: 8px;
  &.ant-checkbox-wrapper .ant-checkbox .ant-checkbox-inner {
    border-color: ${props =>
      props.checked || props.indeterminate ? COLORS.PRIMARY : '#D0D5DD'};
    background-color: ${props => (props.checked ? COLORS.PRIMARY : 'white')};
  }
  &.ant-checkbox-wrapper
    .ant-checkbox.ant-checkbox-indeterminate
    .ant-checkbox-inner::after {
    background-color: ${COLORS.PRIMARY};
  }
`

export const ExpandIcon = styled.span`
  cursor: pointer;
  margin: 0 8px 0 4px;
`

